module.exports = __webpack_public_path__ + "static/media/cateringDeliveryMarketPlace.732cfd26.png";